import React, {Component} from "react"
import ShelfApi from "~/utils/ShelfApi.js"
import {TitleSection, Field, Form, FormSection} from "~/components/"
import {withTranslation} from "react-i18next"

class ForgotPasswordView extends Component {
  state = {
    resetRequested: false,
    email: ""
  }

  onSubmit() {
    return ShelfApi.post("/auth/password", {
      email: this.state.email,
      redirect_url: "password_reset/"
    })
      .then(res => this.setState({email: "", resetRequested: true}))
      .catch(err => console.log(err))
  }

  render() {
    return this.state.resetRequested ? (
      <div>
        <TitleSection>
          <h3>{this.props.t("forgotPassword.title")}</h3>
        </TitleSection>
        <div className="content">
          <p className="sh-text-content forgot-password">
            {this.props.t("forgotPassword.resetRequested")}
          </p>
        </div>
      </div>
    ) : (
      <div>
        <div className="content">
          <Form
            onSubmit={() => this.onSubmit()}
            submitLabel={this.props.t("forgotPassword.submit")}
          >
            <FormSection label="Passwort zurücksetzen">
              <p className="sh-text-content forgot-password no-padding">
                {this.props.t("forgotPassword.requestReset")}
              </p>
              <Field
                label={this.props.t("forgotPassword.email")}
                type="email"
                name="email"
                value={this.state.email}
                onChange={e => this.setState({email: e.target.value})}
              />
            </FormSection>
          </Form>
        </div>
      </div>
    )
  }
}

export default withTranslation()(ForgotPasswordView)



// WEBPACK FOOTER //
// ./src/views/ForgotPasswordView.js